import React from 'react';
import './PrimeryButton.css';
import right from "../../Assets/right.png";

const PrimeryButton = ({
  text, 
  width, 
  height, 
  padding,
  fontSize,
  lineHeight,
  fontWeight,
  color,
  backgroundColor,
  arrowTrue,
  onClick, // ✅ changed from navigateClick
}) => {
  return (
    <button 
      className='main-button' 
      style={{
        width, 
        height, 
        padding,
        fontSize,
        lineHeight,
        fontWeight,
        color,
        backgroundColor // optional: to highlight active category
      }}
      onClick={onClick} // ✅ updated here
    >
      {text}
      {arrowTrue && <img src={right} alt="arrow" />}
    </button>
  );
};

export default PrimeryButton;
